import React, { useEffect } from 'react';

import { Box, ButtonBase, Grid, Typography } from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import SuraCard from '../../../../components/SuraCard';
import { appConfig } from '../../../../config/app';
import { CustomEvents } from '../../../../constants/analytics.constant';
import { incidentRoad } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import useLogEventInAnalytics from '../../../../hooks/useLogAnalyticsEvent';
import SelectRobbery from './SelectRobbery.component';

const CarHasAppeared = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();
  const { logEvent } = useLogEventInAnalytics();

  let robbery: { [index: string]: any } = incidentRoad.robbery;

  useEffect(() => {
    let keytodelete = null;
    // TODO: fix this bad assignation
    robbery = incidentRoad.robbery;
    robbery.forEach((element: any, key: any) => {
      if (
        element.title === 'Daños en mi vehículo' ||
        element.title === 'tipo de daños' ||
        element.title === 'Robo' ||
        element.title === '¿Qué te robaron?' ||
        element.title === 'Neumáticos robados'
      ) {
        keytodelete = key;
      }
    });
    if (keytodelete) robbery.splice(keytodelete, 1);

    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
  }, []);

  const steps = {
    appeared: [
      {
        title: 'Robo',
        content: <SelectRobbery />,
        order: 6,
      },
    ],
  };

  const selectCard = (appeared: boolean) => {
    let keytodelete = null;
    robbery = incidentRoad.robbery;
    logEvent(
      !appeared
        ? CustomEvents.COMPLAINTS_ROBBERY_NOT_APPEARED
        : CustomEvents.COMPLAINTS_ROBBERY_APPEARED,
      {
        app: appConfig?.NAME,
      }
    );
    updateSinisterBody({
      robbery: {
        ...sinister_body.robbery,
        found_car: appeared,
      },
    });

    if (appeared) {
      if (
        !robbery.find((element: { title: any }) => element.title === 'Robo')
      ) {
        steps.appeared.forEach((step) => {
          robbery.push(step);
        });
      } else {
        robbery.forEach((element: any, key: any) => {
          if (
            element.title === 'Robo' ||
            element.title === 'Daños a mi vehículo'
          ) {
            keytodelete = key;
          }
        });
      }
    }

    if (appeared === false) {
      robbery.forEach((element: any, key: any) => {
        if (
          element.title === 'Daños en mi vehículo' ||
          element.title === 'tipo de daños' ||
          element.title === 'Robo'
        ) {
          keytodelete = key;
        }
      });
    }

    if (keytodelete) robbery.splice(keytodelete, 1);

    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));

    nextStep();
  };

  return (
    <Grid item xs={12} sm={6}>
      <Box>
        <Box my={4}>
          <Typography variant="h6" color="textPrimary">
            ¿Apareció el vehículo?
          </Typography>
        </Box>
        <Box mr={3} mb={3}>
          <ButtonBase
            style={{ width: '100%' }}
            onClick={() => selectCard(true)}
          >
            <SuraCard
              // className={
              //   sinister_body[relatedField] === card.value
              //     ? classes.selectedCard
              //     : ""
              // }
              style={{ width: '100%' }}
            >
              <Box
                m={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={'100%'}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box ml={1}>
                    <Typography variant="body1">Sí, apareció</Typography>
                  </Box>
                </Box>
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>

        <Box mr={3} mb={3}>
          <ButtonBase
            style={{ width: '100%' }}
            onClick={() => selectCard(false)}
          >
            <SuraCard
              // className={
              //   sinister_body[relatedField] === card.value
              //     ? classes.selectedCard
              //     : ""
              // }
              style={{ width: '100%' }}
            >
              <Box
                m={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={'100%'}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box ml={1}>
                    <Typography variant="body1">No apareció</Typography>
                  </Box>
                </Box>
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>
      </Box>
    </Grid>
  );
};

export default CarHasAppeared;
